
import { Injectable} from '@angular/core';
import { URL_SERVICIOSBACK, NEW_URL_SERVICIOS_EFIKAR} from '../../../config/config';
import { HttpClient ,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Ingreso } from '../models/ingreso.model';
import Swal from 'sweetalert2';
import { LoadingService } from '../../../services/loading.service';

@Injectable()
export class IngresoService {
  public ingreso:Ingreso
 
  constructor(
    public http: HttpClient,
    private spinnerService: LoadingService
  ) {
   
   }
    
  
    

  listarIngresoValorizado(ingreso) {
    const url = NEW_URL_SERVICIOS_EFIKAR + 'ingreso/listarIngresoValorizado';
    return this.http.post(url, ingreso)
   }

   listarIngresoSinValorizar(ingreso) {
    const url = NEW_URL_SERVICIOS_EFIKAR + 'ingreso/listarIngresoSinValorizar';
    return this.http.post(url, ingreso)
   }
  /**************************************/
  asociarGuias(ingreso) {
    const url = NEW_URL_SERVICIOS_EFIKAR + 'ingreso/asociarGuias';
    return this.http.post(url, ingreso)
   }
 

   
}

